import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {AktiviteterService} from './aktiviteter.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Broderkort} from './models/broderkort';

@Component({
    selector: 'app-broderkort',
    templateUrl: './broderkort.component.html',
})
export class BroderkortComponent implements OnChanges {
    // id: number;
    @Input() broderkort: Broderkort;

    constructor(private aktiviteterService: AktiviteterService, private route: ActivatedRoute, private router: Router) {
    }

    ngOnChanges(): void {
        // this.aktiviteterService.getBroderkort(this.id).then(result => this.broderkort = result);

        // this.route.paramMap.switchMap((params: ParamMap) => this.aktiviteterService.getBroderkort(+params.get('broder_id')))
        // .subscribe((a => this.broderkort = a));
    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/broderkort.component.ts